import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Checkbox from '@bibliocommons/deprecated-base-checkbox';
import AccessibleTextArea from '@bibliocommons/deprecated-base-accessibility-text-area';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { fieldErrorsShape } from '@bibliocommons/bc-prop-types';

import './ContentAdvisoryField.scss';

const CHARACTER_LIMIT = 400;
const DETAILS_ERROR_KEY = 'details';

function renderAsterisk() {
  return (
    <span className="required">
      *
      <ScreenReaderMessage>
        <FormattedMessage id="FIELD_REQUIRED" />
      </ScreenReaderMessage>
    </span>
  );
}

export default class ContentAdvisoryField extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (prevProps.isChecked !== this.props.isChecked && this.textAreaRef) {
      setFocusWithinElement(this.textAreaRef);
    }
  }

  render() {
    const { isChecked, notice, className, label, handleTextChange, handleCheckboxChange, fieldErrors } = this.props;

    return (
      <div className={`cp-content-advisory-field ${className}`}>
        <div className="form-group">
          <Checkbox
            id={`advisory_field_${className}`}
            checked={isChecked}
            label={label}
            handleChange={handleCheckboxChange}
          />
          {isChecked && (
            <div className="ugc-content-advisory-field-text">
              <label htmlFor={`ugc-content-advisory-field-${className}`} className="content-advisory-label">
                <FormattedMessage id="facets_message" />
                {renderAsterisk()}
              </label>
              <AccessibleTextArea
                required
                type="text"
                name="details"
                className="content-advisory-field-textarea"
                id={`ugc-content-advisory-field-${className}`}
                maxLength={CHARACTER_LIMIT}
                handleChange={handleTextChange}
                value={notice}
                ref={el => {
                  this.textAreaRef = el;
                }}
                fieldErrors={fieldErrors}
                errorKey={DETAILS_ERROR_KEY}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

ContentAdvisoryField.propTypes = {
  handleCheckboxChange: PropTypes.func,
  handleTextChange: PropTypes.func,
  isChecked: PropTypes.bool,
  notice: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  fieldErrors: fieldErrorsShape
};
